import { Flex, Input, Text, InputProps } from '@chakra-ui/react';
import { forwardRef, ForwardRefRenderFunction, useCallback, useState } from 'react';

interface Usuario {
  valorFaturamento: string;
  valorTributos: string;
}

export const InputMask: ForwardRefRenderFunction<HTMLInputElement, InputProps> = (
  { id, ...rest },
  ref,
) => {
  const [usuario, setUsuario] = useState<Usuario>({} as Usuario);

  const [isText, setText] = useState({
    valorFaturamento: false,
    valorTributos: false,
  });

  const handleChange = useCallback(
    (e: React.FormEvent<HTMLInputElement>) => {
      if (e.currentTarget.id === 'valorFaturamento' && e.currentTarget.value !== '') {
        setText({
          ...isText,
          valorFaturamento: true,
        });
      } else if (e.currentTarget.id === 'valorFaturamento' && e.currentTarget.value === '') {
        setText({
          ...isText,
          valorFaturamento: false,
        });
      }

      if (e.currentTarget.id === 'valorTributos' && e.currentTarget.value !== '') {
        setText({
          ...isText,
          valorTributos: true,
        });
      } else if (e.currentTarget.id === 'valorTributos' && e.currentTarget.value === '') {
        setText({
          ...isText,
          valorTributos: false,
        });
      }

      setUsuario({
        ...usuario,
        [e.currentTarget.id]: e.currentTarget.value,
      });
    },
    [usuario, isText],
  );

  const handleKeyUp = useCallback((e: React.FormEvent<HTMLInputElement>) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let value = e.currentTarget.value;
    value = value.replace(/\D/g, '');

    value = value.replace(/(\d)(\d{2})$/, '$1,$2');
    value = value.replace(/(?=(\d{3})+(\D))\B/g, '.');
    e.currentTarget.value = value;
  }, []);

  return (
    <Flex align="center" position="relative">
      {isText.valorFaturamento && (
        <Text position="absolute" left="10px" zIndex={1000}>
          R$
        </Text>
      )}

      {isText.valorTributos && (
        <Text position="absolute" left="10px" zIndex={1000}>
          R$
        </Text>
      )}
      <Input
        ref={ref}
        id={id}
        onKeyUp={handleKeyUp}
        paddingLeft="2rem"
        {...rest}
        onChange={handleChange}
      />
    </Flex>
  );
};

export const InputMaskCurrency = forwardRef(InputMask);
